module.exports = __webpack_public_path__ + "static/media/hero-small.1cc4437e.webp";